<template>
  <div class="box">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 右边内容 -->
    <div class="content-right">
      <!-- 标题 个人中心 -->
      <!-- <p class="person-title">个人信息</p> -->
      <!-- 头像盒子 -->
      <div class="person-head">
        <p>我的头像：</p>
        <img
          v-if="mydata.userInfo.avatar !== ''"
          v-complete:src="mydata.userInfo.avatar"
          alt=""
          width="52px"
          height="52px"
          style="border-radius: 100%"
        />
        <!-- 头像2 -->
        <el-row class="demo-avatar demo-basic" v-else>
          <el-col :span="12">
            <div class="demo-basic--circle">
              <div class="block">
                <el-avatar :size="50" v-complete:src="circleUrl" />
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 实名认证 -->
        <p
          v-if="mydata.userInfo.username && mydata.userInfo.identity_card_code"
          class="r-p"
          style="color: #b4b4b4; cursor: unset"
        >
          已实名认证
        </p>
        <p v-else class="r-p" @click="clickReaName">实名认证</p>
        <!-- 修改头像 -->
        <p class="edit-avatar" @click="editAvatarClick">修改头像</p>
      </div>
      <!-- 详细信息 -->
      <div class="person-details">
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="我的昵称：">
              <el-input
                v-model="mydata.userInfo.nickname"
                :disabled="mydata.editInfoDisabled"
              />
            </el-form-item>
          </el-form>
          <!-- <p>我的昵称：</p> -->
          <!-- <p>
          {{ Object.keys(mydata.userInfo).length === 0 ? "未绑定" : mydata.userInfo.nickname }}
        </p> -->
        </div>
        <!-- <p @click="modifySubmit" class="blue-color">确认修改</p> -->
      </div>

      <!-- 身份 -->
      <div class="person-details">
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="注册身份：">
              <el-input
                v-bind:value="mydata.student"
                v-if="mydata.userInfo.user_role === 1"
                disabled
              />
              <el-input
                v-bind:value="mydata.parent"
                v-else-if="mydata.userInfo.user_role === 2"
                disabled
              />
              <el-input
                v-bind:value="mydata.teacher"
                v-else-if="mydata.userInfo.user_role === 3"
                disabled
              />
              <el-input v-bind:value="mydata.merchant" v-else disabled />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="person-details h-auto">
        <div class="details-box h-auto">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="手机号：">
              <el-input
                v-model="mydata.userInfo.phone"
                :disabled="mydata.editInfoDisabled"
              />
            </el-form-item>
            <el-form-item label="验证码：" class="v-code">
              <el-input
                v-model="mydata.userInfo.code"
                style="margin-bottom: 20px"
                :disabled="mydata.editInfoDisabled"
              />
              <el-button
                class="password-button"
                @click="getphoncode"
                :disabled="mydata.btnDisabled || mydata.editInfoDisabled"
                >{{ mydata.btnText }}</el-button
              >
            </el-form-item>
          </el-form>
          <!-- <p>手机号：</p>
        <p>{{ Object.keys(mydata.userInfo).length === 0 ? "未绑定" : mydata.userInfo.phone }}</p> -->
        </div>
        <!-- <p @click="modifySubmitPhone" class="blue-color">确认修改</p> -->
      </div>
      <div class="person-details" v-if="mydata.userInfo.user_role !== 2">
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="学校：">
              <el-input
                v-model="mydata.userInfo.school"
                :disabled="mydata.editInfoDisabled"
              />
            </el-form-item>
          </el-form>
        </div>
        <!-- <p @click="modifySubmit" class="blue-color">确认修改</p> -->
      </div>
      <div
        class="person-details"
        v-if="
          mydata.userInfo.user_role !== 2 && mydata.userInfo.user_role !== 3
        "
      >
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="年级：">
              <!-- <el-input v-model="mydata.userInfo.gradeId" /> -->
              <el-select
                v-model="mydata.userInfo.gradeId"
                placeholder="请选择你的年级"
                :disabled="mydata.editInfoDisabled"
              >
                <el-option
                  v-for="item in mydata.gradeIdOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- <p>年级：</p>
        <p>
          {{ Object.keys(mydata.userInfo).length === 0 ? "未绑定" : mydata.userInfo.gradeId }}
        </p> -->
        </div>
        <!-- <p @click="modifySubmit" class="blue-color">确认修改</p> -->
      </div>
      <div class="person-details" v-if="mydata.userInfo.user_role === 2">
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="省份：">
              <el-input v-model="mydata.userInfo.province" disabled />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="person-details" v-if="mydata.userInfo.user_role === 2">
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="地市：">
              <el-input v-model="mydata.userInfo.city" disabled />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="person-details">
        <div class="details-box">
          <el-form
            :model="mydata.form"
            label-width="auto"
            style="max-width: 343px"
          >
            <el-form-item label="注册日期：">
              <el-input v-model="mydata.userInfo.create_time" disabled />
            </el-form-item>
          </el-form>
          <!-- <p>注册日期：</p>
        <p>{{ Object.keys(mydata.userInfo).length === 0 ? "" : mydata.userInfo.create_time }}</p> -->
        </div>
      </div>
      <div class="person-details h-auto">
        <div class="details-box h-auto" style="display: block">
          <!-- <el-form :model="mydata.form" label-width="auto" style="max-width: 600px">
          <el-form-item label="密码设置：">
            <el-input v-model="mydata.userInfo.gradeId" />
          </el-form-item>
        </el-form> -->
          <!-- <div style="display: flex; margin-top: 20px">
          <p>密码设置：</p>
          <p>******</p>
        </div> -->
          <el-form
            :model="mydata.form"
            label-width="100"
            style="max-width: 343px"
            class="v-pass"
          >
            <el-form-item label="旧密码：">
              <el-input
                v-model="mydata.userInfo.old_pwd"
                :disabled="mydata.editInfoDisabled"
              />
            </el-form-item>
            <el-form-item label="新密码：">
              <el-input
                v-model="mydata.userInfo.new_pwd"
                :disabled="mydata.editInfoDisabled"
              />
            </el-form-item>
            <el-form-item label="确认新密码：">
              <el-input
                v-model="mydata.userInfo.repetition_pwd"
                :disabled="mydata.editInfoDisabled"
              />
            </el-form-item>
          </el-form>
        </div>
        <!-- <p @click="modifySubmitPassword" class="blue-color">确认修改</p> -->
      </div>

      <!-- 开启关闭修改按钮 -->
      <!-- <el-button type="primary" @click="openClose" class="open-close-btn">{{
      mydata.openCloseText
    }}</el-button> -->

      <!-- 确认修改按钮 -->
      <el-button type="primary" @click="editInfo" class="edit-info-btn">{{
        mydata.openCloseText
      }}</el-button>

      <!-- 退出登录按钮 -->
      <el-button type="primary" plain @click="getOut" class="getOut"
        >退出登录</el-button
      >

      <!-- 弹窗 -->
      <el-dialog v-model="mydata.dialogVisible" title="实名认证" width="343">
        <el-form
          ref="formEl"
          :model="mydata.form"
          :rules="mydata.rules"
          label-width="80px"
        >
          <el-form-item label="姓名" prop="username">
            <el-input
              v-model="mydata.form.username"
              placeholder="请填写您的姓名"
            />
          </el-form-item>
          <el-form-item label="身份证号" prop="identity_card_code">
            <el-input
              v-model="mydata.form.identity_card_code"
              placeholder="请填写您的身份证号"
            />
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="submit">确认</el-button>
            <el-button @click="clickReaNameCancel">取消</el-button>
          </div>
        </template>
      </el-dialog>

      <!-- 弹窗 -->
      <el-dialog v-model="mydata.dialogVisible2" title="修改头像" width="343">
        <el-form
          ref="formEl2"
          :model="mydata.form2"
          :rules="mydata.rules2"
          label-width="80px"
          v-if="mydata.dialogVisible2"
        >
          <el-form-item label="上传头像" prop="file">
            <el-upload
              action="#"
              :auto-upload="false"
              :file-list="mydata.fileList"
              :before-upload="beforeUpload"
              :show-file-list="true"
              :on-change="fileChange"
              :on-remove="fileRemove"
              :limit="1"
              :on-exceed="exceedFile"
              :on-preview="uploadPreview"
              list-type="picture-card"
              accept=".jpg,.jpeg,.png"
            >
              <el-icon><Plus /></el-icon>
            </el-upload>
            <el-dialog v-model="mydata.dialogVisible3">
              <img width="100%" v-complete:src="mydata.dialogImageUrl3" />
            </el-dialog>
          </el-form-item>
          <el-form-item>
            <p style="line-height:20px;">请上传宽高比例为1:1的图片，可以使得头像更加美观</p>
          </el-form-item>
        </el-form>

        <div style="width: 100%; height:160px;">
          <vueCropper
            v-if="mydata.dialogVisible2"
            ref="cropper"
            :img="mydata.options.img"
            :outputSize="mydata.options.outputSize"
            :outputType="mydata.options.outputType"
            :info="mydata.options.info"
            :canScale="mydata.options.canScale"
            :autoCrop="mydata.options.autoCrop"
            :autoCropWidth="mydata.options.autoCropWidth"
            :autoCropHeight="mydata.options.autoCropHeight"
            :fixedBox="mydata.options.fixedBox"
            :fixed="mydata.options.fixed"
            :fixedNumber="mydata.options.fixedNumber"
            :canMove="mydata.options.canMove"
            :canMoveBox="mydata.options.canMoveBox"
            :original="mydata.options.original"
            :centerBox="mydata.options.centerBox"
            :infoTrue="mydata.options.infoTrue"
            :full="mydata.options.full"
            :enlarge="mydata.options.enlarge"
            :mode="mydata.options.mode"
          >
          </vueCropper>
        </div>

        <template #footer>
          <div class="dialog-footer">
            <!-- <el-button type="primary" @click="getCropData">裁剪</el-button> -->
            <el-button type="primary" @click="submit2">确认</el-button>
            <el-button @click="clickReaNameCancel2">取消</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { reactive, computed, toRefs, inject, ref } from "vue";
import "vue-cropper/dist/index.css";
import { VueCropper } from "vue-cropper";
//引入OutLogin方法
import {
  outLogin,
  modifyUserInfor,
  modifyUserInfor2,
  sendVerificationCode,
  changePassword,
  changePhoneNumber,
  realName,
  updateUserinfo,
} from "@/api/personalCenter/personalInfor/index.js";
// 引入接口
import { get_grade } from "@/api/login/nowLogin/index.js";
//验证是否为手机号
import { isPhoneNumber } from "@/utils/validate.js";
const updateMydataUserInfo = inject("updateMydataUserInfo");
const updateMydataUserInfo2 = inject("updateMydataUserInfo2");
// import { ElMessage } from 'element-plus'
// import { ComponentSize, FormInstance, FormRules } from "element-plus";

import { Edit } from "@element-plus/icons-vue";

// import { UploadFile } from "element-plus";

function validator_username(rule, value, callback) {
  let reg = /^[\u4e00-\u9fa5]+$/;
  if (reg.test(mydata.form.username)) {
    callback();
  } else {
    callback(new Error("姓名必须全部是汉字"));
  }
}
function validator_identity_card_code(rule, value, callback) {
  let reg =
    /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
  if (reg.test(mydata.form.identity_card_code)) {
    callback();
  } else {
    callback(new Error("身份证号格式错误"));
  }
}

const formEl = ref(null);
const formEl2 = ref(null);
const cropper = ref(null);

const router = useRouter();

// {1:学生,2:教师家长,3:教师}
const mydata = reactive({
  openCloseText: "修改信息",
  editInfoDisabled: true,
  dialogVisible3: false,
  dialogImageUrl3: "",
  fileList: [],
  gradeIdOptions: [],
  dialogVisible: false,
  dialogVisible2: false,

  student: "学生",
  parent: "家长",
  teacher: "老师",
  merchant: "商家",

  form: {
    username: "", //姓名
    identity_card_code: "", //身份证号
  },
  rules: {
    username: [
      {
        required: true,
        message: "请输入姓名",
      },
      { min: 2, max: 5, message: "请输入2~5位的姓名" },
      {
        validator: validator_username,
      },
    ],
    identity_card_code: [
      {
        required: true,
        message: "请输入身份证号",
      },
      { min: 18, max: 18, message: "请输入18位的身份证号" },
      {
        validator: validator_identity_card_code,
      },
    ],
  },

  form2: {
    file: [],
    fileCropper: null,
  },
  rules2: {
    file: [
      {
        required: true,
        message: "请上传头像",
      },
    ],
  },

  size: "default",

  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  btnText: "获取验证码",
  btnDisabled: false,

  options: {
    img: "", // 裁剪图片的地址 url 地址, base64, blob
    outputSize: 1, // 裁剪生成图片的质量
    outputType: "png", // 裁剪生成图片的格式 jpeg, png, webp
    info: true, // 裁剪框的大小信息
    canScale: true, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    autoCropWidth: 200, // 默认生成截图框宽度
    autoCropHeight: 200, // 默认生成截图框高度
    fixedBox: false, // 固定截图框大小 不允许改变
    fixed: true, // 是否开启截图框宽高固定比例，这个如果设置为true，截图框会是固定比例缩放的，如果设置为false，则截图框的狂宽高比例就不固定了
    fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
    canMove: true, // 上传图片是否可以移动
    canMoveBox: true, // 截图框能否拖动
    original: false, // 上传图片按照原始比例渲染
    centerBox: true, // 截图框是否被限制在图片里面
    infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
    full: true, // 是否输出原图比例的截图
    enlarge: "1", // 图片根据截图框输出比例倍数
    mode: "contain", // 图片默认渲染方式 contain , cover, 100px, 100% auto
  },
});

function openClose() {
  if (mydata.editInfoDisabled) {
    mydata.editInfoDisabled = false;
    mydata.openCloseText = "关闭修改";
  } else {
    mydata.editInfoDisabled = true;
    mydata.openCloseText = "开启修改";
  }
}

function editInfo() {
  if (mydata.editInfoDisabled) {
    mydata.editInfoDisabled = false;
    mydata.openCloseText = "确认修改";
    return;
  }
  // console.log(mydata.userInfo);
  // console.log(mydata.userInfo.nickname);
  // console.log(mydata.userInfo.phone);
  // console.log(mydata.userInfo.code);
  // console.log(mydata.userInfo.school);
  // console.log(mydata.userInfo.gradeId);
  // console.log(mydata.userInfo.old_pwd);
  // console.log(mydata.userInfo.new_pwd);
  // console.log(mydata.userInfo.repetition_pwd);

  let reg1 = /^\s*$/;

  // if (reg.test(mydata.userInfo.nickname)) {
  //       ElMessage({
  //     message: "昵称不得为空",
  //     type: "warning",
  //   });
  //   return;
  // }

  if (isPhoneNumber(mydata.userInfo.phone) === false) {
    ElMessage({
      message: "手机号码格式错误",
      type: "warning",
    });
    return;
  }

  let reg2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/;

  mydata.userInfo.old_pwd =
    mydata.userInfo.old_pwd === undefined ? "" : mydata.userInfo.old_pwd;
  mydata.userInfo.new_pwd =
    mydata.userInfo.new_pwd === undefined ? "" : mydata.userInfo.new_pwd;
  mydata.userInfo.repetition_pwd =
    mydata.userInfo.repetition_pwd === undefined
      ? ""
      : mydata.userInfo.repetition_pwd;

  if (
    !reg1.test(mydata.userInfo.old_pwd) ||
    !reg1.test(mydata.userInfo.new_pwd) ||
    !reg1.test(mydata.userInfo.repetition_pwd)
  ) {
    if (
      !reg2.test(mydata.userInfo.old_pwd) ||
      !reg2.test(mydata.userInfo.new_pwd) ||
      !reg2.test(mydata.userInfo.repetition_pwd)
    ) {
      ElMessage({
        message: "密码长度为8-16位，须使用数字、字母大/小写组合",
        type: "warning",
      });
      return;
    }

    if (mydata.userInfo.new_pwd !== mydata.userInfo.repetition_pwd) {
      ElMessage({
        message: "两次新密码不一致",
        type: "warning",
      });
      return;
    }
  }

  // console.log("发送");
  updateUserinfo({
    nickname: mydata.userInfo.nickname,
    school: mydata.userInfo.school,
    gradeId: mydata.userInfo.gradeId,
    // avatar:mydata.userInfo.avatar, // 头像（单独修改）
    old_pwd: mydata.userInfo.old_pwd,
    new_pwd: mydata.userInfo.new_pwd,
    repetition_pwd: mydata.userInfo.repetition_pwd,
    // username:mydata.userInfo.username, // 用户名（单独修改）
    // identity_card_code:mydata.userInfo.identity_card_code,// 身份证号码（单独修改）
    phone: mydata.userInfo.phone,
    code: mydata.userInfo.code,
  }).then((res) => {
    // console.log(res);
    mydata.editInfoDisabled = true;
    mydata.openCloseText = "修改信息";
    ElMessage({
      message: res.msg,
      type: "success",
    });
    if (res.data.reset_password === 0) {
      localStorage.setItem("userInfo", JSON.stringify(mydata.userInfo));
      updateMydataUserInfo();
      updateMydataUserInfo2();
    } else {
      // 清除本地缓存
      localStorage.removeItem("userInfo");
      // 改变layout组件里面的数据
      updateMydataUserInfo2();

      // 跳转页面到首页
      router.push({
        // path: "/layout/list/personalCenter",
        // path: "/layout/list/home",
        path: "/login/nowLogin",
      });
    }
  });

  //   if (reg.test(mydata.userInfo.school)) {
  //       ElMessage({
  //     message: "学校不得为空",
  //     type: "warning",
  //   });
  //   return;
  // }
}

const { circleUrl, sizeList } = toRefs(mydata);

//获取验证码,按钮点击事件
function getphoncode() {
  // 如果不是手机号，那么提醒弹窗并终止代码
  if (isPhoneNumber(mydata.userInfo.phone) === false) {
    ElMessage({
      message: "手机号码格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled = true;
  let num = 60;
  let intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用sendVerificationCode方法，发送请求
  sendVerificationCode(mydata.userInfo.jwt, {
    phone: mydata.userInfo.phone,
  })
    .then((res) => {
      // console.log(res.data,"手机号获取验证码")
      // 存储后端返回的用户信息
      // localStorage.setItem("userInfo", JSON.stringify(res.data));
      // // 提示弹窗
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // // 跳转页面
      // router.push({
      //   path: "/login/retrievePasswordLogin",
      // });
    })
    .catch((err) => {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    });
}

//退出登录事件
function getOut() {
  ///调用OutLogin方法（发送请求）
  outLogin(mydata.userInfo.jwt).then((res) => {
    // console.log(res, "退出登录");
    // mydata.getout = res.data,data
    //退出登录弹窗
    ElMessage({
      message: res.msg,
      type: "success",
    });

    // 清除本地缓存
    localStorage.removeItem("userInfo");
    // 改变layout组件里面的数据
    updateMydataUserInfo2();

    // 跳转页面到首页
    router.push({
      // path: "/layout/list/personalCenter",
      path: "/layout/list/home",
    });
  });
}

//////修改用户信息（昵称/学校/年级）————点击事件
function modifySubmit() {
  ///调用modifyUserInfor方法（发送请求）
  modifyUserInfor(mydata.userInfo.jwt, {
    nickname: mydata.userInfo.nickname,
    school: mydata.userInfo.school,
    gradeId: mydata.userInfo.gradeId,
  }).then((res) => {
    // console.log(res, "修改用户信息");
    // mydata.getout = res.data,data
    //修改成功
    ElMessage({
      message: res.msg,
      type: "success",
    });
    localStorage.setItem("userInfo", JSON.stringify(mydata.userInfo));
    updateMydataUserInfo();
    updateMydataUserInfo2();
  });
}

//////修改手机号————点击事件
function modifySubmitPhone() {
  ///调用changePhoneNumber方法（发送请求）
  changePhoneNumber(mydata.userInfo.jwt, {
    phone: mydata.userInfo.phone,
    code: mydata.userInfo.code,
  }).then((res) => {
    //修改成功
    ElMessage({
      message: res.msg,
      type: "success",
    });
    mydata.userInfo.code = "";
    localStorage.setItem("userInfo", JSON.stringify(mydata.userInfo));
  });
}

//////修改密码————点击事件
function modifySubmitPassword() {
  // console.log(mydata.userInfo.old_pwd);
  // console.log(mydata.userInfo.new_pwd);
  // console.log(mydata.userInfo.repetition_pwd);

  if (!mydata.userInfo.old_pwd) {
    ElMessage({
      message: "旧密码不得为空",
      type: "warning",
    });
    return;
  }

  if (!mydata.userInfo.new_pwd) {
    ElMessage({
      message: "新密码不得为空",
      type: "warning",
    });
    return;
  }

  let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/;

  if (!reg.test(mydata.userInfo.new_pwd)) {
    ElMessage({
      message: "密码长度为8-16位，须使用数字、字母大/小写组合",
      type: "warning",
    });
    return;
  }

  // 这一步判断必须写在前两个判断之后，因为要考虑到新密码和确认新密码都没有输入内容的情况
  if (mydata.userInfo.new_pwd !== mydata.userInfo.repetition_pwd) {
    ElMessage({
      message: "两次新密码不一致",
      type: "warning",
    });
    return;
  }

  ///调用changePassword方法（发送请求）
  changePassword(mydata.userInfo.jwt, {
    old_pwd: mydata.userInfo.old_pwd,
    new_pwd: mydata.userInfo.new_pwd,
    repetition_pwd: mydata.userInfo.repetition_pwd,
  }).then((res) => {
    //修改成功
    ElMessage({
      message: res.msg,
      type: "success",
    });

    // 清除本地缓存
    localStorage.removeItem("userInfo");
    // 改变layout组件里面的数据
    updateMydataUserInfo2();

    // 跳转页面到首页
    router.push({
      // path: "/layout/list/personalCenter",
      // path: "/layout/list/home",
      path: "/login/nowLogin",
    });
  });
}

//////发送重置手机号验证码
function sendPhoneCode() {
  ///调用sendVerificationCode方法（发送请求）
  sendVerificationCode(mydata.userInfo.jwt, {
    phone: mydata.userInfo.phone,
  }).then((res) => {
    // console.log(res, "发送重置手机号验证码");
    // mydata.getout = res.data,data
    //发送成功
    ElMessage({
      message: res.msg,
      type: "success",
    });
  });
}

// 实名认证
function clickReaName() {
  // 重置数据
  mydata.form.username = "";
  mydata.form.identity_card_code = "";
  // 打开弹窗
  mydata.dialogVisible = true;
}

// 实名认证
function clickReaNameCancel() {
  // 关闭弹窗
  mydata.dialogVisible = false;
  // 重置数据
  mydata.form.username = "";
  mydata.form.identity_card_code = "";
}

//实名认证的事件函数
function submit() {
  formEl.value.validate((v) => {
    if (v) {
      // realName(mydata.userInfo.jwt, mydata.form).then((res) => {
      updateUserinfo({
        nickname: mydata.userInfo.nickname,
        school: mydata.userInfo.school,
        gradeId: mydata.userInfo.gradeId,
        ...mydata.form,
      }).then((res) => {
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // 关闭弹窗
        mydata.dialogVisible = false;
        //////////////////
        localStorage.setItem("userInfo", JSON.stringify(res.data.user_info));
        updateMydataUserInfo();
        updateMydataUserInfo2();
        //////////////////
        mydata.userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {};
        //////////////////
      });
    }
  });
}

function getGradeIdOptions() {
  get_grade().then((res) => {
    mydata.gradeIdOptions = res.data;
  });
}
getGradeIdOptions();

function editAvatarClick() {
  mydata.dialogVisible2 = true;
  mydata.form2.file = [];
  mydata.form2.fileCropper = null;
  mydata.options.img = "";
  mydata.fileList = [];
  mydata.dialogImageUrl3 = "";
}

function beforeUpload(file) {
  const MAX_SIZE = 1024 * 1024 * 5; // 设定最大文件大小为5MB
  if (file.size > MAX_SIZE) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    return false; // 返回false停止上传
  }
  return true; // 返回true允许上传
}

function fileChange(file, fileList) {
  mydata.form2.file = fileList.map((item) => {
    return item.raw;
  });

  mydata.options.img = mydata.form2.file[0]
    ? URL.createObjectURL(mydata.form2.file[0])
    : "";
  // console.log(mydata.options.img);

  formEl2.value.validateField("file");
}

// 获取裁剪出来的数据
function getCropData() {
  // 获取裁剪出来的blob数据
  cropper.value.getCropBlob((data) => {
    mydata.form2.fileCropper = new File([data], mydata.form2.file[0].name, {
      type: mydata.form2.file[0].name,
      lastModified: mydata.form2.file[0].lastModified,
    });
  });
}

function fileRemove(file, fileList) {
  mydata.form2.file = fileList.map((item) => {
    return item.raw;
  });

  mydata.options.img = mydata.form2.file[0]
    ? URL.createObjectURL(mydata.form2.file[0])
    : "";
  // console.log(mydata.options.img);

  formEl2.value.validateField("file");
}

function exceedFile() {
  // 提示弹窗
  ElMessage({
    message: "只可上传一个文件",
    type: "warning",
  });
}

function submit2() {
  // console.log(mydata.form2);
  formEl2.value.validate((v) => {
    if (v) {
      cropper.value.getCropBlob((data) => {
        mydata.form2.fileCropper = new File([data], mydata.form2.file[0].name, {
          type: mydata.form2.file[0].name,
          lastModified: mydata.form2.file[0].lastModified,
        });

        let formDataObj = new FormData();
        // formDataObj.append("avatar", mydata.form2.file[0]);
        formDataObj.append("avatar", mydata.form2.fileCropper);
        formDataObj.append("nickname", mydata.userInfo.nickname);
        formDataObj.append("school", mydata.userInfo.school);
        formDataObj.append("gradeId", mydata.userInfo.gradeId);
        // 调用接口
        // modifyUserInfor2(mydata.userInfo.jwt, formDataObj).then((res) => {
        updateUserinfo(formDataObj).then((res) => {
          //
          mydata.userInfo.avatar = res.data.user_info.avatar;
          localStorage.setItem("userInfo", JSON.stringify(mydata.userInfo));
          updateMydataUserInfo();
          updateMydataUserInfo2();
          // 提示弹窗
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 关闭弹窗
          mydata.dialogVisible2 = false;
        });
      });
    }
  });
}

function clickReaNameCancel2() {
  mydata.dialogVisible2 = false;
}

// 文件预览事件
function uploadPreview(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible3 = true;
  // 赋值地址
  mydata.dialogImageUrl3 = file.url;
}

// sendPhoneCode()
</script>

<style scoped lang="scss">
.box {
  ////右边内容
  .content-right {
    // width: 950px;
    // height: 784px;
    height: auto;
    padding-bottom: 200px;
    background-color: #ffffff;
    // border:1px solid rgb(0, 255, 34);
    // padding-left: 62px;
    position: relative;
    // border: 1px solid red;
    margin-top: 16px;

    //标题个人信息
    // .person-title {
    //   font-size: 18px;
    //   font-weight: 400;
    //   color: #282828;
    //   line-height: 60px;
    //   border-bottom: 1px solid #ececec;
    // }

    //头像盒子
    .person-head {
      // width: 904px;
      background-color: #ffffff;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #0000001a;
      position: relative;
      > p {
        font-size: 14px;
        font-weight: 400;
        color: #282828;
      }
      > .r-p {
        color: #409eff;
        font-size: 14px;
        cursor: pointer;
        position: absolute;
        top: 60%;
        right: 16px;
      }
      > .edit-avatar {
        position: absolute;
        right: 16px;
        top: 20%;
        font-size: 14px !important;
        color: #409eff !important;
        cursor: pointer;
      }

      ////////头像样式
      :deep(.el-row.demo-avatar.demo-basic) {
        width: 52px;
        height: 52px;
        // border: 1px solid red;
        // 头像框
        .demo-basic--circle {
          width: 52px;
          height: 52px;
          // border:1px solid red;
        }
        //头像框
        .block {
          width: 52px;
          height: 52px;
          // border:1px solid red;
        }
        //圆头像
        .el-avatar.el-avatar--circle {
          width: 52px;
          height: 52px;
          // border: 1px solid blue;
        }
      }
    }

    //详细信息
    .person-details {
      // width: 904px;
      height: 70px;
      font-size: 14px;
      font-weight: 400;
      color: #282828;
      padding: 0px 16px;
      line-height: 22px;
      border-bottom: 1px dashed #0000001a;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        // margin-left: 40px;
      }
      > p {
        cursor: pointer;
      }
      .details-box {
        height: 70px;
        // border: 1px solid rgb(60, 0, 255);
        display: flex;
        // justify-content: space-between;
        align-items: center;
        p:nth-of-type(1) {
          width: 100px;
          //  border:1px solid blue;
        }
        //form表单
        :deep(.el-form.el-form--default.el-form--label-right) {
          // border: 1px solid red;
          //from表单
          .el-form-item.asterisk-left {
            margin-top: 18px;
            // border: 1px solid yellow;
            //左边字体
            .el-form-item__label-wrap {
              width: 100px !important;
              text-align: left !important;
              // border: 1px solid blue;
            }
            .el-form-item__label {
              color: #282828;
            }
            //输入框
            .el-form-item__content {
              width: calc(343px - 100px);
              // border:1px solid red;
              .el-input {
                border: none;
                outline: none; /* 可以去除点击输入框时产生的轮廓 */
                .el-input__wrapper {
                  border: none;
                  outline: none;
                  //  border:1px solid red;
                  .el-input__inner {
                    color: #282828;
                  }
                }
              }
            }
          }

          //手机号验证码
          .el-form-item.asterisk-left.v-code {
            // border: 1px solid red;
            height: 30px;
            //输入框
            .el-input {
              width: 140px !important;
              // box-shadow: 0px 0px 0px 0px red;
            }
            .el-button.password-button {
              // border:1px solid red;
              margin-top: -20px !important;
              border: none;
            }
          }
        }
      }
    }

    //退出登录按钮
    :deep(.el-button.el-button--primary.getOut) {
      width: 130px;
      height: 40px;
      font-size: #ffffff;
      font-weight: 400;
      position: absolute;
      right: 54px;
      bottom: 51px;
    }
  }
  //电话号码 与 密码 的高度自适应
  .h-auto {
    height: auto !important;
    // border: 1px solid red;
  }

  //确认修改
  .blue-color {
    color: #409eff;
  }
  //密码设置
  :deep(.v-pass) {
    .el-form-item__label {
      text-align: left !important;
      justify-content: flex-start !important;
    }
  }

  .open-close-btn {
    width: 130px;
    height: 40px;
    font-size: #ffffff;
    font-weight: 400;
    position: absolute;
    left: 0;
    bottom: 51px;
  }
  .edit-info-btn {
    width: 343px;
    height: 45px;
    font-size: #ffffff;
    font-weight: 400;
    border-radius: 30px;
    // margin: 0 auto;
    position: absolute;
    // right: calc(50% - 65px);
    right: 16px;
    bottom: 95px;
    // margin:0 auto;
  }

  .el-button.el-button--primary.is-plain.getOut {
    width: 343px;
    height: 45px;
    font-size: #ffffff;
    font-weight: 400;
    border-radius: 30px;
    // margin: 0 auto;
    position: absolute;
    // right: calc(50% - 65px);
    right: 16px;
    bottom: 40px;
  }
}

//弹窗
:deep(.el-dialog) {
  border-radius: 0px;

  .el-form-item.is-required.asterisk-left{
    //作品上传的框框大小
    .el-form-item__content {
      .el-upload-list.el-upload-list--picture-card {

        .el-upload-list__item.is-ready{
          width: 100px;
          height: 100px;
        }
        // margin-right: 30px;
        .el-upload.el-upload--picture-card {
          width: 100px;
          height: 100px;
        }
      }

      .el-upload-list__item.is-success {
        width: 100px;
        height: 100px;
        .el-upload-list__item-actions {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
}
</style>
